import { styled, Typography } from '@mui/material';

function FormationInitialeSuccess() {
    return (
        <Container>
            <Title variant="h1">Formulaire envoyé</Title>
            <Subtitle variant="h3">Votre candidature a bien été prise en compte.</Subtitle>
            <Typography variant="h3">Merci de nous envoyer sans tarder :</Typography>
            <List>
                <Typography variant="h3">
                    <li>
                        Attestation du diplôme le plus élevé, ou les deux relevés de notes les plus
                        récents
                    </li>
                </Typography>
                <Typography variant="h3">
                    <li>
                        Pièce d’identité (passeport ou carte nationale d’identité + carte de séjour
                        pour les étudiants de nationalité étrangère résidant en France)
                    </li>
                </Typography>
            </List>
            <TextWithMarginBottom variant="h3">
                à l'adresse <strong>admin@esaj.asso.fr</strong>
            </TextWithMarginBottom>
            <Typography variant="h3">
                <strong>Seuls les dossiers complets seront examinés.</strong>
            </Typography>
        </Container>
    );
}

const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    padding: theme.spacing(8),
    textAlign: 'center',
}));

const List = styled('ol')(({ theme }) => ({
    textAlign: 'left',
    margin: theme.spacing(2),
    width: '80%',
}));
const Title = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));
const Subtitle = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(4),
}));

const TextWithMarginBottom = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

export { FormationInitialeSuccess };
